import React, { useEffect, useState } from "react";
import { useMeetingHistory } from "store/actions";
import Columns from "./Columns";
import { useDispatch } from "react-redux";
import Table from "components/Table";
import { FadeLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import DoctorColumns from "./DoctorColumns";
 
const MeetingHistoryPatient = ({ user_id, userType, filtereddoctorsData, isFiltered, selected, count, setNextPage, setNewFilter, newFilter }) => {
  const [meetingData, setMeetingData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const navigate = useNavigate();
  const [columns, setcolumns] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
  }); 
  useEffect(() => {
    // MeetingHistory(filter);
    setcolumns(
      Columns({
        currentPage: filter?.pageNo,
        pageSize,
        handleViewUser,
      })
    );
  }, [user_id, filter]);
  const MeetingHistory = () => {
    setLoading(true);
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      user_id: user_id,
      userType: userType,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          console.log(err);
          setLoading(false);
        } else {
          console.log(res, "response");
          setMeetingData(res);
          setLoading(false);
        }
      };
      dispatch(useMeetingHistory({ data: payload, callback }));
    } catch (error) {
      console.log(error);
    }
  };
  console.log(meetingData?.meeting_data, "meetingData");
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleViewUser = (row) => {
    console.log(row, "row data");
    let path;
    if(typeof row?.meeting_information === "string"){
      path = `${row?.meeting_information}`
    }
    else {
      path = `${row?.meeting_information[0]?.meeting_id}?meetingType=${selected}`
    }
    navigate(path, { state: { row } });
  }; 
  //   const handleViewUserDoctor = (row) => {
  //   console.log(row, "row data");
  //   navigate(`${row?.meeting_information[0]?.meeting_id}`, { state: { row } });
  // }; 
  return (
    <>
     {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {/* {!loading && !isFiltered &&
      (meetingData?.meeting_data?.length > 0 ? (
        <div className="tab-pane fade show active">
          <Table
            data={meetingData?.meeting_data}
            columns={columns}
            setFilter={setFilter}
            totalCount={meetingData?.total_record_count}
            handleTableChange={handlePageChange}
            filter={filter}
          />
        </div>
      ) : (
        <p style={{ textAlign: "center" }}>No data Found</p>
      ))} */}
            {
        ((filtereddoctorsData?.length > 0 && isFiltered) ? (
          <div className="tab-pane fade show active">
            <Table
              data={filtereddoctorsData}
              columns={DoctorColumns({ filtereddoctorsData, handleViewUser })}
              setFilter={setNewFilter}
              totalCount={count}
              handleTableChange={handlePageChange}
              filter={newFilter}
            />
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No data Found</p>
        ))}
    </>
  );
};

export default MeetingHistoryPatient;
